import { Component, computed, inject, Input, signal } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { NzImageModule } from 'ng-zorro-antd/image';
import { InstructionPopupItem } from '../../models/popup.model';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-overlay-card-item',
  imports: [NzImageModule, NgClass, NgStyle],
  templateUrl: './overlay-card-item.html',
  styleUrls: ['./overlay-card-item.scss'],
})
export class OverlayCardItemComponent {
  private ui = inject(UiService);
  @Input({ required: false }) isInlet = false;
  @Input({ required: true }) item: InstructionPopupItem = {
    title: GLOBAL_CONSTANT.EMPTY_STRING,
    text: GLOBAL_CONSTANT.EMPTY_STRING,
    image: GLOBAL_CONSTANT.EMPTY_STRING,
    textbold: false,
  };

  // Signals for image dimensions
  clientWidth = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  clientHeight = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  naturalWidth = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  naturalHeight = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);

  // Computed signal for mobile check
  readonly isMobile = computed(() => this.ui.IsMobile());

  // Image load handler
  onImageLoaded(event: Event) {
    const target = event.target as HTMLImageElement;
    this.clientWidth.set(target.clientWidth);
    this.clientHeight.set(target.clientHeight);
    this.naturalWidth.set(target.naturalWidth);
    this.naturalHeight.set(target.naturalHeight);
  }
}
